import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import { omit } from 'lodash';
/**
 * WordPress dependencies
 */

import { Component, createRef } from '@wordpress/element';
import { withGlobalEvents } from '@wordpress/compose';
/**
 * Browser dependencies
 */

var _window = window,
    FocusEvent = _window.FocusEvent;

var FocusableIframe =
/*#__PURE__*/
function (_Component) {
  _inherits(FocusableIframe, _Component);

  function FocusableIframe(props) {
    var _this;

    _classCallCheck(this, FocusableIframe);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FocusableIframe).apply(this, arguments));
    _this.checkFocus = _this.checkFocus.bind(_assertThisInitialized(_this));
    _this.node = props.iframeRef || createRef();
    return _this;
  }
  /**
   * Checks whether the iframe is the activeElement, inferring that it has
   * then received focus, and calls the `onFocus` prop callback.
   */


  _createClass(FocusableIframe, [{
    key: "checkFocus",
    value: function checkFocus() {
      var iframe = this.node.current;

      if (document.activeElement !== iframe) {
        return;
      }

      var focusEvent = new FocusEvent('focus', {
        bubbles: true
      });
      iframe.dispatchEvent(focusEvent);
      var onFocus = this.props.onFocus;

      if (onFocus) {
        onFocus(focusEvent);
      }
    }
  }, {
    key: "render",
    value: function render() {
      // Disable reason: The rendered iframe is a pass-through component,
      // assigning props inherited from the rendering parent. It's the
      // responsibility of the parent to assign a title.

      /* eslint-disable jsx-a11y/iframe-has-title */
      return createElement("iframe", _extends({
        ref: this.node
      }, omit(this.props, ['iframeRef', 'onFocus'])));
      /* eslint-enable jsx-a11y/iframe-has-title */
    }
  }]);

  return FocusableIframe;
}(Component);

export default withGlobalEvents({
  blur: 'checkFocus'
})(FocusableIframe);
//# sourceMappingURL=index.js.map